module.exports = __webpack_public_path__ + "back.59d048a7.png";